import { groupsOrderIndexBulkResourceFilterUpdate } from '@dispatch/shared/services';
import { ResourceFilterGroup } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const UseGroupsOrderIndexBulkResourceFiltersUpdate = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-resource-filter-group', userId],
    (data: ResourceFilterGroup[]) =>
      groupsOrderIndexBulkResourceFilterUpdate(data, userId),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    groupsOrderIndexBulkUpdate: mutate,
    groupsOrderIndexBulkUpdateError: error,
    groupsOrderIndexBulkUpdateStatus: status,
  };
};
